import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { CREATE_BOOKING_CHECK_OUT } from 'graphql/service';
import { useMutation } from '@apollo/client';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';
import { message } from 'antd';

const ModalCheckOutConfirm = ({
  isOpen,
  setIsOpen,
  danger,
  success,
  roomString,
  checkOutBookings,
  buttonLabel,
  buttonStyle,
  setItems,
  setBookingDetailsData,
  refetch
}) => {

  const [createBookingCheckOut, { loading }] = useMutation(CREATE_BOOKING_CHECK_OUT)

  const handleCheckOut = () => {
    if (loading) return
    const checkOutBookingIdArray = checkOutBookings?.map(booking => booking.bookingId)
    const bookingIdSet = new Set(checkOutBookingIdArray)
    createBookingCheckOut({
      variables: {
        input: {
          ids: checkOutBookingIdArray
        }
      }
    }).then((res) => {
      setIsOpen(false)
      message.success('Check out successfully')
      refetch && refetch()
      setItems && setItems((prevItems) => prevItems.map(item => {
        if(bookingIdSet.has(item.id.split('/')[0])) {
          return { ...item, status: 'CHECKED_OUT' };
        }
        return item;
      }))
      setBookingDetailsData && setBookingDetailsData((prevData) => {
        if(bookingIdSet.has(prevData?.bookingByID?.bookingId)) {
          return {
            ...prevData,
            bookingByID: {
              ...prevData.bookingByID,
              status: 'CHECKED_OUT'
            }
          }
        }
        return prevData;
      })
    }).catch((error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content);
      }
    })
  }

  const rooms = roomString
    ? roomString
    : checkOutBookings.reduce((acc, booking, index, array) => {
        if (!booking.roomBookings?.[0]?.room?.roomNumber) {
          return acc;
        } else {
          const roomString = `room ${booking.roomBookings?.[0]?.room?.roomNumber}`;
          if (index === 0) {
            return roomString
          } else if (index === array.length - 1) {
            return `${acc} and ${roomString}`;
          } else {
            return `${acc}, ${roomString}`;
          }
        }
      }, '');

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className={'modal-success'}
      danger={danger}
      success={success}
      buttonLabel={buttonLabel}
      buttonStyle={buttonStyle}
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <div className='text'>Are you sure you want to proceed with the checkout for {rooms}?</div>
        <Button
          success
          onClick={handleCheckOut}
          data-loading={loading}
          additionalstyle={`
            width: 105px;
            margin-top: 24px;
          `} 
        >
          {loading? null: 'Check Out'}
        </Button>
      </Container>
    </MainModal>
  );
}

export default ModalCheckOutConfirm;
